import { navigateToPage } from '../services/navigateCode';
import { getNewToken, getToken } from './GenerateToken';
import { Encrypt } from '../services/Encrypt';
// import { useNavigate } from 'react-router-dom';

// const navigate = useNavigate();
export async function commonAPI(
  endPointKey,
  body = null,
  endPointVariableKey = null,
  navigation
) {
  // api-test-next.curo.in
  // const MasterApi = "https://api-test-next.curo.in";
  // const MasterApi = "https://api.curonext.com";

  const MasterApi = process.env.REACT_APP_MASTER_API
  
  const BaseURL = process.env.REACT_APP_API_KEY_DEV_MODE
  console.log("BASE URL", endPointKey, `${endPointVariableKey}`);
  const storedUsername = localStorage.getItem('userData');
  const myUserData = JSON.parse(storedUsername);
  // if(){}
  // && endPointKey != "CuroProducts" && endPointKey != "PortalLogin" &&  endPointKey != "GetCuroNextUserMapping"


  // console.log("@loginIssue@HitAPI", );

  const APIObj = {
    Country: {
      endPoint: `${BaseURL}/api/Common/Country`,
      method: 'GET',
    },
    State: {
      endPoint: `${BaseURL}/api/Common/State/${endPointVariableKey}`,
      method: 'GET',
    },
    City: {
      endPoint: `${BaseURL}/api/Common/City/${endPointVariableKey}`,
      method: 'GET',
    },
    Client: {
      endPoint: `${BaseURL}/api/Common/Client`,
      method: 'GET',
    },
    ClientLite: {
      endPoint: `${BaseURL}/api/Common/ClientLite`,
      method: 'GET',
    },
    ClientAdd: {
      endPoint: `${BaseURL}/api/Common/Client`,
      method: 'POST',
    },
    ClientUpdate: {
      endPoint: `${BaseURL}/api/Common/Client`,
      method: 'PUT',
    },
    CuroProducts: {
      endPoint: `${BaseURL}/api/Common/CuroProducts`,
      method: 'GET',
    },
    BuildingLite: {
      endPoint: `${BaseURL}/api/Common/BuildingLite`,
      method: 'GET',
    },
    Building: {
      endPoint: `${BaseURL}/api/Common/Building`,
      method: 'GET',
    },
    BuildingAdd: {
      endPoint: `${BaseURL}/api/Common/Building`,
      method: 'POST',
    },
    BuildingUpdate: {
      endPoint: `${BaseURL}/api/Common/Building`,
      method: 'PUT',
    },
    OTPAsync: {
      endPoint: `${BaseURL}/api/Notification/OTPAsync`,
      method: 'POST',
    },
     ValidateOTP: {
        endPoint: `${BaseURL}/api/Notification/ValidateOTP`,
        method: 'POST',
      },
    BuildingDelete: {
      endPoint: `${BaseURL}/api/Common/Building`,
      method: 'DELETE',
    },
    Gate: {
      endPoint: `${MasterApi}/api/Master/Gate`,
      method: 'GET',
    },
    GateAdd: {
      endPoint: `${MasterApi}/api/Master/Gate`,
      method: 'POST',
    },
    GateUpdate: {
      endPoint: `${MasterApi}/api/Master/Gate`,
      method: 'PUT',
    },
    GateDelete: {
      endPoint: `${MasterApi}/api/Master/Gate`,
      method: 'DELETE',
    },
    GroupGateLevel: {
      endPoint: `${MasterApi}/api/Master/GroupGateLevel`,
      method: 'GET',
    },
    Flat: {
      endPoint: `${MasterApi}/api/Master/Flat`,
      method: 'GET',
    },
    FlatAdd: {
      endPoint: `${MasterApi}/api/Master/Flat`,
      method: 'POST',
    },
    FlatDelete: {
      endPoint: `${MasterApi}/api/Master/Flat`,
      method: 'DELETE',
    },
    FlatUpdate: {
      endPoint: `${MasterApi}/api/Master/Flat`,
      method: 'PUT',
    },
    NoticeRecipient: {
      endPoint: `${MasterApi}/api/Notice/NoticeRecipient/${endPointVariableKey?.urlVariable}`,
      // endPoint: `${MasterApi}/api/Notice/NoticeRecipient/10002`,
      method: 'GET',
    },
    Tower: {
      endPoint: `${MasterApi}/api/Master/Tower`,
      method: 'GET',
    },
    TowerDelete: {
      endPoint: `${MasterApi}/api/Master/Tower`,
      method: 'DELETE',
    },
    TowerUpdate: {
      endPoint: `${MasterApi}/api/Master/Tower`,
      method: 'PUT',
    },
    TowerAdd: {
      endPoint: `${MasterApi}/api/Master/Tower`,
      method: 'POST',
    },
    Notice: {
      endPoint: `${MasterApi}/api/Notice/NoticeList`,
      method: 'POST',
    },
    ExpiredNoticeList:{
      endPoint: `${MasterApi}/api/Notice/ExpiredNoticeList`,
      method: 'POST',
    },
    NoticeType: {
      endPoint: `${MasterApi}/api/Notice/NoticeType`,
      method: 'GET',
    },
    NoticeAdd: {
      endPoint: `${MasterApi}/api/Notice/Notice`,
      method: 'POST',
    },
    NoticeImagesAdd: {
      endPoint: `${MasterApi}/api/Notice/NoticeImages`,
      method: 'POST',
    },
    NoticeImages: {
      endPoint: `${MasterApi}/api/Notice/NoticeImages/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    NoticeImagesDelete: {
      endPoint: `${MasterApi}/api/Notice/NoticeImages`,
      method: 'DELETE',
    },
    NoticeUpdate: {
      endPoint: `${MasterApi}/api/Notice/Notice`,
      method: 'PUT',
    },
    NoticeDelete: {
      endPoint: `${MasterApi}/api/Notice/Notice`,
      method: 'DELETE',
    },
    ApproveNotice: {
      endPoint: `${MasterApi}/api/Notice/ApproveNotice`,
      method: 'PUT',
    },
    NoticeRecipientAdd: {
      endPoint: `${MasterApi}/api/Notice/NoticeRecipient`,
      method: 'POST',
    },
    // CuroNextUserMappingStatus: {
    //   endPoint: `${BaseURL}/api/User/CuroNextUserMappingStatus/${endPointVariableKey?.buildingId}/${endPointVariableKey?.urlVariable}`,
    //   method: 'GET',
    // },
    CuroNextUserApproveDeny: {
      endPoint: `${BaseURL}/api/User/CuroNextUserApproveDeny`,
      method: 'POST',
    },
    PendingResVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/PendingResVehicle/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    VehicleImages: {
      endPoint: `${MasterApi}/api/Vehicle/VehicleImages/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ApproveResidentVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/ApproveResidentVehicle/${endPointVariableKey}`,
      method: 'PUT',
    },
    GetCuroNextUserMapping: {
      endPoint: `${BaseURL}/api/User/GetCuroNextUserMapping`,
      method: 'POST',
    },
    CuroNextUserFamily: {
      endPoint: `${BaseURL}/api/User/CuroNextUserFamily/0/true`,
      method: 'GET',
    },
    CuroNextUserFamilyParent: {
      endPoint: `${BaseURL}/api/User/CuroNextUserFamily/${endPointVariableKey}/true`,
      method: 'GET',
    },
    CuroNextUserFamilyList: {
      endPoint: `${BaseURL}/api/User/CuroNextUserFamily/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ResidentVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicle/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    GetResidentVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/GetResidentVehicle`,
      method: 'POST',
    },
    PendingResVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/PendingResVehicle/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ResidentVehicleImage: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicleImages/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ResidentVehicleDoc: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicleDoc/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ApproveResidentVehicle: {
      endPoint: `${MasterApi}/api/Vehicle/ApproveResidentVehicle`,
      method: 'PUT',
    },
    CuroNextUserMappingStatus: {
      endPoint: `${BaseURL}/api/User/CuroNextUserMappingStatus`,
      method: 'POST',
    },
    CuroNextUserMappingAdd: {
      endPoint: `${BaseURL}/api/User/CuroNextUserMapping`,
      method: 'POST',
    },
    UserGateMappingPortal: {
      endPoint: `${MasterApi}/api/User/UserGateMappingPortal`,
      method: 'POST',
    },
    User: {
      endPoint: `${BaseURL}/api/User/User`,
      method: 'POST',
    },
    UserUpdate: {
      endPoint: `${BaseURL}/api/User/User`,
      method: 'PUT',
    },
    DeleteUserOrFamily: {
      endPoint: `${BaseURL}/api/User/DeleteUserOrFamily`,
      method: 'POST',
    },
    UserImage: {
      endPoint: `${BaseURL}/api/User/UserImage`,
      method: 'POST',
    },
    MobileOTP: {
      endPoint: `${BaseURL}/api/Notification/MobileOTP`,
      method: 'POST',
    },
    EmailOTP: {
      endPoint: `${BaseURL}/api/Notification/EmailOTP`,
      method: 'POST',
    },
    PortalLogin: {
      endPoint: `${BaseURL}/api/User/PortalLogin`,
      method: 'POST',
    },
    ChangePassword: {
      endPoint: `${BaseURL}/api/User/ChangePassword`,
      method: 'POST',
    },
    ForgotPassword: {
      endPoint: `${BaseURL}/api/User/ForgotPassword`,
      method: 'POST',
    },
    Token: {
      endPoint: `${BaseURL}/api/User/token`,
      method: 'POST',
    },
    Login: {
      endPoint: `${BaseURL}/api/User/Login`,
      method: 'POST',
    },
    LoginGet: {
      endPoint: `${BaseURL}/api/User/Login/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    ResetPrimaryUser: {
      endPoint: `${BaseURL}/api/User/ResetPrimaryUser`,
      method: 'POST',
    },
    ResetResiding: {
      endPoint: `${BaseURL}/api/User/ResetResiding`,
      method: 'POST',
    },
    FamilyTransfer: {
      endPoint: `${MasterApi}/api/Utility/FamilyTransfer`,
      method: 'POST',
    },
    CuroNextUserApproveDeny: {
      endPoint: `${BaseURL}/api/User/CuroNextUserApproveDeny`,
      method: 'POST',
    },
    CuroNextUserMappingComment: {
      endPoint: `${BaseURL}/api/User/CuroNextUserMapping/${endPointVariableKey}`,
      method: 'GET',
    },
    ResidentVehicleList: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicle`,
      method: 'GET',
    },
    ResidentVehicleAdd: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicle`,
      method: 'POST',
    },
    ResidentVehicleUpdate: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicle`,
      method: 'PUT',
    },
    ResidentVehicleDelete: {
      endPoint: `${MasterApi}/api/Vehicle/ResidentVehicle`,
      method: 'DELETE',
    },
    DashboardData: {
      endPoint: `${MasterApi}/api/Dashboard/DashboardData${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    AppSettings: {
      endPoint: `${MasterApi}/api/Master/AppSettings`,
      method: 'GET',
    },
    AppSettingsAdd: {
      endPoint: `${MasterApi}/api/Master/AppSettings`,
      method: 'POST',
    },
    AppSettingsUpdate: {
      endPoint: `${MasterApi}/api/Master/AppSettings`,
      method: 'PUT',
    },
    VehicleFuelType: {
      endPoint: `${BaseURL}/api/Common/VehicleFuelType`,
      method: 'GET',
    },
    VehicleBrand: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: 'GET',
    },
    MapFasTag: {
      endPoint: `${MasterApi}/api/Vehicle/MapFasTag`,
      method: 'POST',
    },
    ResidentInOutReport: {
      endPoint: `${MasterApi}/api/Report/ResidentInOutReport`,
      method: 'POST',
    },
    WalkinVisitorInOutReport: {
      endPoint: `${MasterApi}/api/Report/WalkinVisitorInOutReport`,
      method: 'POST',
    },
    VisitorInOutReport: {
      endPoint: `${MasterApi}/api/Report/VisitorInOutReport`,
      method: 'POST',
    },
    ServiceStaffInOutReport: {
      endPoint: `${MasterApi}/api/Report/ServiceStaffInOutReport`,
      method: "POST",
    },
    mangeVehicleOwner: {
      endPoint: `${MasterApi}/api/Vehicle/VehicleByNumber/${endPointVariableKey?.urlVariable}`,
      method: 'GET',
    },
    resetVehicleOwnerShip: {
      endPoint: `${MasterApi}/api/Vehicle/ResetVehicleOwnership`,
      method: 'POST',
    },
    ErrorLogMaster: {
      endPoint: `${BaseURL}/api/Common/ErrorLog`,
      method: 'POST',
    },
    getVehicleLogo: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: "GET"
    },
    VehicleBrandPost: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: 'POST',
    },
    getCompanyLogo: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "GET"
    },
    VisitorCompany: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "POST"
    },
    ApigetParamete: {
      endPoint: `${MasterApi}/api/Visitor/GetInviteVisitor`,
      method: "POST"
    },
    getVehicleLogo: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: "GET"
    },
    DeleteVehicleLogo: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: "DELETE"
    },
    updateVehicleLogo: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: "PUT"
    },
    VehicleBrandPost: {
      endPoint: `${BaseURL}/api/Common/VehicleBrand`,
      method: 'POST',
    },
    getCompanyLogo: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "GET"
    },
    delteCompanyLogo: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "DELETE"
    },
    updateCompanyLogo: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "PUT"
    },
    VisitorCompany: {
      endPoint: `${MasterApi}/api/Master/Company`,
      method: "POST"
    },
    ImportTags: {
      endPoint: `${MasterApi}/api/Utility/ImportTags`,
      method: "POST"
    },
    ImportUserTags: {
      endPoint: `${MasterApi}/api/Utility/ImportUserTags`,
      method: "POST"
    },
    RFIDTag: {
      endPoint: `${MasterApi}/api/Vehicle/RFIDTag/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    UnmapRFIDTag: {
      endPoint: `${MasterApi}/api/Vehicle/UnmapRFIDTag`,
      method: "POST"
    },
    RFIDTagAdd: {
      endPoint: `${MasterApi}/api/Vehicle/RFIDTag`,
      method: "POST"
    },
    RFIDTagUpdate: {
      endPoint: `${MasterApi}/api/Vehicle/RFIDTag`,
      method: "PUT"
    },
    ImportTags: {
      endPoint: `${MasterApi}/api/Utility/ImportTags`,
      method: "POST"
    },
    ImportUserTags: {
      endPoint: `${MasterApi}/api/Utility/ImportUserTags`,
      method: "POST"
    },
    UserTag: {
      endPoint: `${MasterApi}/api/User/UserTag/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    GetUserTag: {
      endPoint: `${MasterApi}/api/User/UserTag`,
      method: "GET"
    },
    UnmapUserTag: {
      endPoint: `${MasterApi}/api/User/UnmapUserTag`,
      method: "POST"
    },
    UserTagAdd: {
      endPoint: `${MasterApi}/api/User/UserTag`,
      method: "POST"
    },
    UserTagUpdate: {
      endPoint: `${MasterApi}/api/User/UserTag`,
      method: "PUT"
    },
    DeleteUserTag: {
      endPoint: `${MasterApi}/api/User/DeleteUserTag`,
      method: "POST"
    },
    AntiPassback: {
      endPoint: `${MasterApi}/api/Master/AntiPassback`,
      method: "POST"
    },
    DeleteRFIDTag: {
      endPoint: `${MasterApi}/api/Vehicle/DeleteRFIDTag`,
      method: "POST"
    },
    ApigetParamete: {
      endPoint: `${MasterApi}/api/Visitor/GetInviteVisitor`,
      method: "POST"
    },
    updateVehicleNumber: {
      endPoint: `${MasterApi}/api/Visitor/InviteVisitor`,
      method: "POST"
    },
    // OverstayVisitors: {
    //   endPoint: `${MasterApi}/api/Transit/OverstayVisitors`,
    //   method: "GET"
    // },
    OverstayVisitors: {
      endPoint: `${MasterApi}/api/Transit/OverstayVisitors?PageNumber=${endPointVariableKey?.PageNumber ?? 0}&PageSize=${endPointVariableKey?.PageSize ?? 10}`,
      method: "GET"
    },
    GetTemplateKeys: {
      endPoint: `${BaseURL}/api/Notification/TemplateKeys`,
      method: "GET"
    },
    AddUpdateTemplateKeys: {
      endPoint: `${BaseURL}/api/Notification/TemplateKeys`,
      method: "POST"
    },
    AppSettings: {
      endPoint: `${MasterApi}/api/Master/AppSettings`,
      method: "GET"
    },
    AppSettingsCopy: {
      endPoint: `${MasterApi}/api/Master/AppSettingsCopy`,
      method: "POST"
    },
    DeleteAccount: {
      endPoint: `${BaseURL}/api/User/CuroNextUser`,
      method: "DELETE"
    },
    ComplaintStatus: {
      endPoint: `${MasterApi}/api/Master/ComplaintStatus`,
      method: "GET"
    },
    GetServiceStaff: {
      endPoint: `${MasterApi}/api/User/GetServiceStaff`,
      method: "POST"
    },
    ActiveNextAppUser: {
      endPoint: `${BaseURL}/api/User/ActiveNextAppUser/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    ServiceStaffAppAccess: {
      endPoint: `${MasterApi}/api/User/ServiceStaffAppAccess`,
      method: "POST"
    },
    ServiceStaffRevokeAppAccess: {
      endPoint: `${MasterApi}/api/User/ServiceStaffRevokeAppAccess`,
      method: "POST"
    },
    GetComplaint: {
      endPoint: `${MasterApi}/api/Complaint/GetComplaint`,
      method: "POST"
    },
    ComplaintCategory: {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "GET"
    },
    ComplaintCategoryAdd: {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "POST"
    },
    ComplaintCategoryUpdate: {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "PUT"
    },
    ComplaintCategoryDelete: {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "DELETE"
    },
    ComplaintSubCategory: {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    ComplaintSubCategoryAdd: {
      endPoint: `${MasterApi}/api/Master/ComplaintSubCategory`,
      method: "POST"
    },
    ComplaintSubCategoryUpdate: {
      endPoint: `${MasterApi}/api/Master/ComplaintSubCategory`,
      method: "PUT"
    },
    ComplaintSubCategoryDelete: {
      endPoint: `${MasterApi}/api/Master/ComplaintSubCategory`,
      method: "DELETE"
    },
    Department: {
      endPoint: `${MasterApi}/api/Master/Department`,
      method: "GET"
    },
    DepartmentAdd: {
      endPoint: `${MasterApi}/api/Master/Department`,
      method: "POST"
    },
    DepartmentUpdate: {
      endPoint: `${MasterApi}/api/Master/Department`,
      method: "PUT"
    },
    DepartmentDelete: {
      endPoint: `${MasterApi}/api/Master/Department`,
      method: "DELETE"
    },
    SocietyRole: {
      endPoint: `${MasterApi}/api/Master/Department/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    SocietyRoleAdd: {
      endPoint: `${MasterApi}/api/Master/SocietyRole`,
      method: "POST"
    },
    SocietyRoleUpdate: {
      endPoint: `${MasterApi}/api/Master/SocietyRole`,
      method: "PUT"
    },
    SocietyRoleDelete: {
      endPoint: `${MasterApi}/api/Master/SocietyRole`,
      method: "DELETE"
    },
    ServiceStaff: {
      endPoint: `${MasterApi}/api/User/GetServiceStaff`,
      method: "POST"
    },
    ServiceStaffAdd: {
      endPoint: `${MasterApi}/api/User/ServiceStaff`,
      method: "POST"
    },
    ServiceStaffUpdate: {
      endPoint: `${MasterApi}/api/User/ServiceStaff`,
      method: "PUT"
    },
    ServiceStaffDelete: {
      endPoint: `${MasterApi}/api/User/DeleteServiceStaff`,
      method: "POST"
    },
    ServiceStaffImage: {
      endPoint: `${MasterApi}/api/User/ServiceStaffImage`,
      method: "POST"
    },
    RaiseComplaint: {
      endPoint: `${MasterApi}/api/Complaint/Complaint`,
      method: "POST"
    },
    GetComplaintPOST: {
      endPoint: `${MasterApi}/api/Complaint/GetComplaint`,
      method: "POST"
    },
    ComplaintById: {
      endPoint: `${MasterApi}/api/Complaint/ComplaintById/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    updateComplaint: {
      endPoint: `${MasterApi}/api/Complaint/Complaint`,
      method: "PUT"
    },
    ComplaintComments: {
      endPoint: `${MasterApi}/api/Complaint/ComplaintComments`,
      method: "POST"
    },
    ComplaintDashboardStatusWise: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardStatusWise`,
      method: "GET"
    },
    ComplaintDashboardCategoryWise: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardCategoryWise`,
      method: "GET"
    },
    ComplaintDashboardAgingCount: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardAgingCount`,
      method: "POST"
    },
    ComplaintDashboardMonthlyCount: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardMonthlyCount`,
      method: "GET"
    },
    ComplaintDashboardMetrics: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardMetrics`,
      method: "GET"
    },
    ComplaintDashboardAssigned: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardAssigned`,
      method: "GET"
    },
    ComplaintDashboardTopResolved: {
      endPoint: `${MasterApi}/api/Dashboard/ComplaintDashboardTopResolved`,
      method: "GET"
    },
    AccessControlType: {
      endPoint: `${MasterApi}/api/User/AccessControlType`,
      method: "GET"
    },
    UserGateMapping: {
      endPoint: `${MasterApi}/api/User/UserGateMapping`,
      method: "POST"
    },
    MapUserTag: {
      endPoint: `${MasterApi}/api/User/MapUserTag`,
      method: "POST"
    },
    Reason: {
      endPoint: `${MasterApi}/api/Master/Reason/COMPLAINT`,
      method: "GET"
    },
    AccessControlType: {
      endPoint: `${MasterApi}/api/User/AccessControlType`,
      method: "GET"
    },
    AccessControlTypeAdd: {
      endPoint: `${MasterApi}/api/User/AccessControlType`,
      method: "POST"
    },
    AccessControlTypeDelete: {
      endPoint: `${MasterApi}/api/User/AccessControlType/${endPointVariableKey?.accessTypeId}`,
      method: "DELETE"
    },
    GroupGateLevel: {
      endPoint: `${MasterApi}/api/Master/GroupGateLevel`,
      method: "GET"
    },
    AddGroupGateLevel: {
      endPoint: `${MasterApi}/api/Master/GroupGateLevel`,
      method: "POST"
    },
    UpdateGroupGateLevel: {
      endPoint: `${MasterApi}/api/Master/GroupGateLevel`,
      method: "PUT"
    },
    GroupGateLevelDel: {
      endPoint: `${MasterApi}/api/Master/GroupGateLevel/${endPointVariableKey?.levelId}`,
      method: "DELETE"
    },
    GetGroupInviteVisitor: {
      endPoint: `${MasterApi}/api/Visitor/GetGroupInviteVisitor`,
      method: "POST"
    },
    MyVisitorListPost: {
      endPoint: `${MasterApi}/api/Visitor/Visitor`,
      method: 'POST'
    },
    visitorType: {
      endPoint: `${MasterApi}/api/Visitor/VisitorTypes`,
      method: "GET"
    },
    PriorityContacts: {
      endPoint: `${MasterApi}/api/Master/PriorityContacts`,
      method: "GET"
    },
    PriorityContactsAdd: {
      endPoint: `${MasterApi}/api/Master/PriorityContacts`,
      method: "POST"
    },
    PriorityContactsUpdate: {
      endPoint: `${MasterApi}/api/Master/PriorityContacts`,
      method: "PUT"
    },
    PriorityContactsDelete: {
      endPoint: `${MasterApi}/api/Master/PriorityContacts/${endPointVariableKey?.urlVariable}`,
      method: "DELETE"
    },
    PriorityContactType: {
      endPoint: `${MasterApi}/api/Master/PriorityContactType`,
      method: "GET"
    },
    GetReportScheduling : {
      endPoint: `${MasterApi}/api/Report/ReportScheduling`,
      method: "GET"
    },
    AddReportScheduling: {
      endPoint: `${MasterApi}/api/Report/ReportScheduling`,
      method: "POST"
    },
    UpdateReportScheduling: {
      endPoint: `${MasterApi}/api/Report/ReportScheduling`,
      method: "PUT"
    },
    DeleteReportScheduling: {
      endPoint: `${MasterApi}/api/Report/ReportScheduling`,
      method: "DELETE"
    },
    GetReportMaster : {
      endPoint: `${MasterApi}/api/Report/GetReportMaster`,
      method: "GET"
    },
    AddReportMaster : {
      endPoint: `${MasterApi}/api/Report/ReportMaster`,
      method: "POST"
    },
    DeleteReportMaster : {
      endPoint: `${MasterApi}/api/Report/DeleteReportMaster`,
      method: "POST"
    },
    UpdateReportMaster : {
      endPoint: `${MasterApi}/api/Report/UpdateReportMaster`,
      method: "POST"
    },
    GetComplaintEsclation : {
      endPoint: `${MasterApi}/api/Complaint/ComplaintEscalation`,
      method: "GET"
    },
    AddComplaintEsclation : {
      endPoint: `${MasterApi}/api/Complaint/ComplaintEscalation`,
      method: "POST"
    },
    DeleteComplaintEsclation : {
      endPoint: `${MasterApi}/api/Complaint/DeleteComplaintEscalation`,
      method: "POST"
    },
    UpdateComplaintEsclation : {
      endPoint: `${MasterApi}/api/Complaint/UpdateComplaintEscalation`,
      method: "POST"
    },
    GetComplaintCategory : {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "GET"
    },
    AddComplaintCategory : {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "POST"
    },
    DeleteComplaintCategory : {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "DELETE"
    },
    UpdateComplaintCategory : {
      endPoint: `${MasterApi}/api/Master/ComplaintCategory`,
      method: "PUT"
    },
    ReportSchedulingRunNow : {
      endPoint: `${MasterApi}/api/Report/ReportSchedulingRunNow`,
      method: "POST"
    },
    AddComplaintEscalationRecipient : {
      endPoint: `${MasterApi}/api/Complaint/EscalationRecipient`,
      method: "POST"
    },
    NoticeRecipientHistory : {
      endPoint: `${MasterApi}/api/Notice/NoticeRecipientList/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    NoticeDocumentUpload : {
      endPoint: `${MasterApi}/api/Notice/NoticeAttachment`,
      method: "POST"
    },
    ServiceStaffStats : {
      endPoint: `${MasterApi}/api/User/ServiceStaffStats/${endPointVariableKey?.urlVariable}`,
      method: "GET"
    },
    ServiceStaffList : {
      endPoint: `${MasterApi}/api/User/ServiceStaffList`,
      method: "POST"
    },
    DocumentMaster : {
      endPoint: `${MasterApi}/api/Master/DocumentMaster`,
      method: "GET"
    },
       DocumentMasterService : {
      endPoint: `${MasterApi}/api/Master/DocumentMaster/Identity`,
      method: "GET"
    },
    ServiceStaffV1 : {
      endPoint: `${MasterApi}/api/User/ServiceStaffV1`,
      method: "POST"
    },
      GetServiceStaffDetail : {
      endPoint: `${MasterApi}/api/Master/GetServiceStaffDetail`,
      method: "POST"
    },

      UpdateServiceStaffDetail: {
      endPoint: `${MasterApi}/api/User/ServiceStaffV1`,
      method: "PUT"
    },

        TransitLogDetail : {
      endPoint: `${MasterApi}/api/User/GetServiceStaffTransitLog`,
      method: "POST"
    },

    

  }

  const hitAPI = async () => {
    try {
      let token;
      const tokenString = await getToken();
      token = "Bearer " + tokenString; // Added a space after "Bearer"
      console.log("token is", token);
    
      // Check if the user is online (optional)
      // if (!navigator.onLine) {
      //   // toast.warning("You are offline. Please check your internet connection.");
      //   return; // Stop further execution when offline
      // }
    
      console.log("API ENDPOINT: ", APIObj[endPointKey].endPoint, endPointVariableKey?.buildingId, endPointVariableKey?.ProductId, token);
    
      let response = await fetch(APIObj[endPointKey].endPoint, {
        method: APIObj[endPointKey].method,
        headers: endPointKey !== "ImportTags" && endPointKey !== "ImportUser Tags" ? {
          'Content-Type': 'application/json',
          "BuildingId": endPointVariableKey?.buildingId || null,
          // "AppSecretKey": endPointVariableKey?.buildingId ? Encrypt(String(endPointVariableKey?.buildingId)) : null,
          "ProductId": endPointVariableKey?.ProductId || null,
          // "AppProductSecretKey": endPointVariableKey?.ProductId ? Encrypt(String(endPointVariableKey?.ProductId)) : null,
          "Authorization": token
        } : {
          'Accept': 'application/json',
          "BuildingId": endPointVariableKey?.buildingId || null,
          // "AppSecretKey": endPointVariableKey?.buildingId ? Encrypt(String(endPointVariableKey?.buildingId)) : null,
          "ProductId": endPointVariableKey?.ProductId || null,
          // "AppProductSecretKey": endPointVariableKey?.ProductId ? Encrypt(String(endPointVariableKey?.ProductId)) : null,
          "Authorization": token
        },
        body: (endPointKey === "ImportTags" && body) ? body : (endPointKey !== "ImportTags" && body) ? JSON.stringify(body) : null,
      });
    
      if ([200, 400, 401, 500].includes(response.status)) {
        // Handle 401 status specifically for Login endpoint
        if (response.status === 401) {
          if (endPointKey === "Login") {
            // Handle 401 for Login endpoint
            return response.json(); // Return the response for Login
          } else {
            // For other endpoints, attempt to refresh the token
            let newToken = await getNewToken();
            console.log("New token is", newToken);
            let responseAuth = await fetch(APIObj[endPointKey].endPoint, {
              method: APIObj[endPointKey].method,
              headers: endPointKey !== "ImportTags" && endPointKey !== "ImportUser Tags" ? {
                'Content-Type': 'application/json',
                "BuildingId": endPointVariableKey?.buildingId || null,
                // "AppSecretKey": endPointVariableKey?.buildingId ? Encrypt(String(endPointVariableKey?.buildingId)) : null,
                "ProductId": endPointVariableKey?.ProductId || null,
                // "AppProductSecretKey": endPointVariableKey?.ProductId ? Encrypt(String(endPointVariableKey?.ProductId)) : null,
                "Authorization": newToken
              } : {
                'Accept': 'application/json',
                "BuildingId": endPointVariableKey?.buildingId || null,
                // "AppSecretKey": endPointVariableKey?.buildingId ? Encrypt(String(endPointVariableKey?.buildingId)) : null,
                "ProductId": endPointVariableKey?.ProductId || null,
                // "AppProductSecretKey": endPointVariableKey?.ProductId ? Encrypt(String(endPointVariableKey?.ProductId)) : null,
                "Authorization": newToken
              },
              body: (endPointKey === "ImportTags" && body) ? body : (endPointKey !== "ImportTags" && body) ? JSON.stringify(body) : null,
            });
    
            if ([200, 400, 401, 500].includes(responseAuth.status)) {
              return responseAuth.json(); // Return the response from the re-authenticated request
            }
          }
        }
        return response.json(); // Return the response for other statuses
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error('API Request Error:', error);
    }

  }
  // to prevent api hit in case of unauthorized access!
  if (storedUsername) {
    return hitAPI()
  } else {
    if (endPointKey == "CuroProducts" || endPointKey == "GetCuroNextUserMapping" || endPointKey == "Token" || endPointKey == "Login" || endPointKey == "ForgotPassword" || endPointKey == "MobileOTP" || endPointKey == "EmailOTP" || endPointKey == "GetGroupInviteVisitor" || endPointKey == "MyVisitorListPost" || endPointKey == "visitorType") {
      // console.log("runninghh###################")
      return hitAPI()
    }
  }

}
